import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=67ed39ed"
import script from "./GlobalLayout.vue?vue&type=script&lang=js"
export * from "./GlobalLayout.vue?vue&type=script&lang=js"
import style0 from "./GlobalLayout.vue?vue&type=style&index=0&id=67ed39ed&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ed39ed')) {
      api.createRecord('67ed39ed', component.options)
    } else {
      api.reload('67ed39ed', component.options)
    }
    module.hot.accept("./GlobalLayout.vue?vue&type=template&id=67ed39ed", function () {
      api.rerender('67ed39ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/GlobalLayout.vue"
export default component.exports